import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

/**
 * Guard that allows Development OR Demo users to access System Tools routes.
 *
 * ROLE ACCESS:
 * - Development: ✅
 * - Demo: ✅
 * - Others: ❌ → redirect to their default route
 */
export const SystemToolsGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authState = inject(AuthState);

  // Allow if user has development access OR demo access
  if (authState.hasDevelopmentAccess() || authState.hasDemoAccess()) {
    return true;
  }

  console.log('[SystemToolsGuard] Access denied - redirecting to:', authState.defaultRoute());
  router.navigate([authState.defaultRoute()]);
  return false;
};
